/**
 * @description Because SXF attaches the master product ID to the permalink, this function removes
 * the master product ID from the permalink if it exists to match other brands.
 * @param {String} identifier unique idenfitier for the product
 * @returns {String} the transformed identifier if necessary, or, the original identifier
 */
function transformIdentifier(identifier) {
  // does the `identifier` end with "-number-number"?
  // e.g. "product-123-456"
  if (/-\d+-\d+$/.test(identifier)) {
    // remove the last "-number" from the end of the `identifier`
    // e.g. "product-123-456" becomes "product-123"
    return identifier.replace(/-\d+$/, '');
  }

  return identifier;
}

export default transformIdentifier;
